export default class DamageInfo{
	apDamage = 0;
	adDamage = 0;
	trueDamage = 0;
	manaSpent = 0;
	rank = 0;

	getTotalDamage(){
		return this.apDamage + this.adDamage + this.trueDamage;
	}

	getRank(){
		return this.rank;
	}

	add(damageInfo:DamageInfo){
		this.apDamage+=damageInfo.apDamage;
		this.adDamage+=damageInfo.adDamage;
		this.trueDamage+=damageInfo.trueDamage;
		this.manaSpent+=damageInfo.manaSpent;
	}
}/**
 * Created by jeffb on 4/14/2017.
 */



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/calculation/DamageInfo.ts